import { frontendURL } from 'dashboard/helper/URLHelper';

const TimeClockIndex = () => import('./pages/TimeClockIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/time-clock'),
      name: 'time_clock_index',
      component: TimeClockIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
